import axios from 'axios';
import config from '../config';
import { store } from '../store';

const getHeaders = () => {
  const { authToken } = store.getState().user;
  return { authorization: authToken };
};

const base = () => `${config.apiBaseUrl}/icici`;

export const getOpsState = () =>
  axios.get(`${base()}/instant/ops-state`, { headers: getHeaders() })
    .then((r) => r.data);

export const manualAssign = (consultationId, doctorId) =>
  axios.post(`${base()}/instant/manual-assign`, { consultationId, doctorId }, { headers: getHeaders() })
    .then((r) => r.data);

export const setDoctorStatus = (status) =>
  axios.post(`${base()}/instant/doctor-status`, { status }, { headers: getHeaders() })
    .then((r) => r.data);

export const getDoctorState = () =>
  axios.get(`${base()}/instant/doctor-state`, { headers: getHeaders() })
    .then((r) => r.data);

export const startCall = (consultationId) =>
  axios.post(`${base()}/instant/start-call`, { consultationId }, { headers: getHeaders() })
    .then((r) => r.data);

export const completeCall = (consultationId) =>
  axios.post(`${base()}/instant/complete-call`, { consultationId }, { headers: getHeaders() })
    .then((r) => r.data);

export const claimCase = (consultationId) =>
  axios.post(`${base()}/instant/claim-case`, { consultationId }, { headers: getHeaders() })
    .then((r) => r.data);

export const setOpsDoctorStatus = (doctorId, status) =>
  axios.post(`${base()}/instant/ops-doctor-status`, { doctorId, status }, { headers: getHeaders() })
    .then((r) => r.data);

export const onDoctorConnect = () =>
  axios.post(`${base()}/instant/on-connect`, {}, { headers: getHeaders() })
    .then((r) => r.data);

export const registerInstantCase = (payload) =>
  axios.post(`${base()}/instant/register-case`, payload, { headers: getHeaders() })
    .then((r) => r.data);
